import DateOfDay from 'components/date/dateOfDay'
import SwitchParcours from 'components/switch-parcours/switch-parcours'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import './header.scss'

export default function Header({ setCounter }: { setCounter: (value: number) => void }) {
   const lang = useSelector((state: any) => state.languageReducer.language)
   return (
      <header className='flex column'>
         <section className='flex flexEnd row top'>
            <SwitchParcours />
            <Link to='/accueil' className=''>
               <img src={`${process.env.PUBLIC_URL}/img/logo.png`} alt='logo' width={480} />
            </Link>
            <div onClick={() => setCounter(290)}>
               <DateOfDay format={lang} />
            </div>
         </section>
      </header>
   )
}
